@if (show) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <img
        class="my-4"
        [src]="iconPath"
        width="82px"
        alt="Indica status do alerta">
      @if (message) {
        <p class="titulo-alert"
          [ngClass]="textColor"
        [innerHTML]="message"></p>
      }
      <div class="rounded-bottom pt-4 pb-3 px-2"
        [ngClass]="[textColor, bgColor]">
        @if (description) {
          <p class="subtitulo-alert"
          [innerHTML]="description"></p>
        }
        <div class="mt-4">
          @for (button of buttons; track button) {
            <button
              [ngClass]="button.className"
              id='btn{{button.text}}'
              (click)="button.action($event)"
            [innerHTML]="button.text || ''"></button>
          }
        </div>
      </div>
    </div>
  </div>
}
